import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { SharedStateAuthModule } from '@emi/shared/state/auth';
import { SharedUiModule } from '@emi/shared/ui';
import { SkuCapsuleUiModule } from '@emi/sku-capsule/ui';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app.routing.module';
import { DefaultRouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { AuthModule, OidcConfigService } from 'angular-auth-oidc-client';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConfigureDataCanDeactivateGuard, HttpErrorService, SaveAndExtractCanDeactivateGuard, SharedDataAccessModule } from '@emi/shared/data-access';
import { SharedStateFiltersModule } from '@emi/shared/state/filters';
import { SharedStateHelpResourcesModule } from '@emi/shared/state/help-resources';
import { SharedStateSkuMetadataModule } from '@emi/shared/state/sku-metadata';
import { SharedStateSkuSearchModule } from '@emi/shared/state/sku-search';
import { SharedConfig } from '@emi/shared/models';
import { HelpResourcesModule } from '@emi/shared/help-resources';
import { ExportRouteComponent } from './export-route/export-route.component';

export const sharedConfig: SharedConfig = {
    passportHelpServiceUrl: environment.passportHelpServiceUrl,
    helpServiceUrl: environment.helpServiceUrl,
    redirectFeedback: environment.redirectFeedback,
    subscriberServiceUrl: environment.subscriberServiceUrl,
    apiBaseUrl: environment.apiBaseUrl,
};

@NgModule({
    declarations: [AppComponent, ExportRouteComponent],
    imports: [
        HttpClientModule,
        AppRoutingModule,
        BrowserModule,
        SharedStateAuthModule.forRoot(sharedConfig),
        SharedDataAccessModule.forRoot(sharedConfig),
        InfiniteScrollModule,
        SharedStateSkuSearchModule,
        SharedUiModule,
        SharedStateFiltersModule.forRoot(environment),
        SharedStateHelpResourcesModule,
        HelpResourcesModule,
        SharedStateSkuMetadataModule,
        SkuCapsuleUiModule,
        BrowserAnimationsModule,
        MatMomentDateModule,
        AuthModule.forRoot({
            config: environment.authSettings,
        }),
        StoreRouterConnectingModule.forRoot({
            serializer: DefaultRouterStateSerializer,
        }),
        StoreModule.forRoot(
            {},
            {
                metaReducers: [],
                runtimeChecks: {
                    strictActionImmutability: true,
                    strictStateImmutability: true,
                },
            }
        ),
        EffectsModule.forRoot([]),
        !environment.production
            ? StoreDevtoolsModule.instrument({
                  maxAge: 25,
                  logOnly: !environment.production,
                  autoPause: true,
              })
            : [],
        AppRoutingModule,
    ],
    providers: [
        OidcConfigService,
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorService, multi: true },
        ConfigureDataCanDeactivateGuard,
        SaveAndExtractCanDeactivateGuard
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
